<!-- Side Navbar -->
<nav class="side-navbar shadow" [ngClass]="{ 'show': isTogglerActive, 'shrink': isTogglerActive}">
    <div class="side-navbar-wrapper">
        <!-- Sidebar Header    -->
        <div class="sidenav-header d-flex align-items-center justify-content-center">
            <!-- User Info-->
            <div class="sidenav-header-inner text-center">
                <i class="bi bi-person-circle m-primary" style="font-size: 300%; margin-right: 0rem; margin-bottom: 0rem;"></i>
                <h4 class="text-break">
                    {{user?.first_name | uppercase}} {{user?.last_name | uppercase}}
                </h4>
                <span>{{getRoles() | uppercase}}</span>
            </div>
            <!-- Small Brand information, appears on minimized sidebar-->
            <div class="sidenav-header-logo">
                <a routerLink="/dashboard" class="brand-small text-center">
                    <i class="bi bi-person-circle m-primary" style="font-size: 3rem; margin-right: 0rem; margin-bottom: 0rem;"></i>
                </a>
            </div>
        </div>
        <!-- main menu-->
        <div class="main-menu">
            <h5 class="sidenav-heading">Main</h5>
            <ul class="nav flex-column">
                <ng-container *ngIf="isRegionalManager || isReporter">
                    <li class="nav-item">
                        <a routerLink="/dashboard" routerLinkActive="active" class="nav-link">
                            <i class="bi bi-bar-chart-line-fill"></i>
                            <span>Dashboard</span>
                        </a>
                    </li>
                </ng-container>
                <ng-container *ngIf="isAdmin">
                    <li class="nav-item">
                        <a routerLink="/users" routerLinkActive="active" class="nav-link">
                            <i class="bi bi-people-fill"></i>
                            <span>User Management</span>
                        </a>
                    </li>
                </ng-container>
                <ng-container *ngIf="isUser">
                    <li class="nav-item">
                        <a routerLink="/support" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="nav-link">
                            <i class="bi bi-headset"></i>
                            <span>Support</span>
                        </a>
                    </li>
                </ng-container>
                <!-- <ng-container *ngIf="isAdmin">
          <li class="nav-item">
            <a routerLink="/users/beta" routerLinkActive="active" class="nav-link">
              <i class="bi bi-people-fill"></i>
              <span>User Management1</span>
            </a>
          </li>
        </ng-container> -->

            </ul>
        </div>
    </div>
</nav>

<div class="page" [ngClass]="{ 'active': isTogglerActive}">
    <!-- navbar-->
    <nav class="navbar navbar-expand-lg navbar-primary bg-primary shadow">
        <div class="container-fluid">
            <a class="navbar-brand" class="menu-btn" (click)="toggleIsActive()">
                <i class="bi bi-list" style="font-size: 2rem;"></i>
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <button type="button" class="btn btn-outline-info" style="padding-bottom: .35rem; padding-top: .35rem; min-width: 2rem;" (click)="signOut()">
              Sign out
            </button>
                    </li>
                    <!-- <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle dropdown-btn" href="#" id="navbarDropdown" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-gear-fill" style="font-size: 1.3rem;"></i>
            </a>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
              <li>
                <hr class="dropdown-divider">
              </li>
              <li>
                <a class="dropdown-item" (click)="signOut()" style="cursor: pointer;">
                  <i class="bi bi-box-arrow-right" style="margin-right: 1rem;"></i>
                  Sign Out
                </a>
              </li>
            </ul>
          </li> -->
                </ul>
            </div>
        </div>
    </nav>
    <!-- router outlet -->
    <div class="container-fluid my-3">
        <router-outlet></router-outlet>
    </div>
</div>